

export default {
  enums: [
    { id: 'UTILISATION' },
    { id: 'DROPOUT' },
  ]
};